import { isMac } from '../../utils/system.utils.js';

export function tooltipShortcut(content, shortcut) {
    // Extract the information about which keys are included
    const containsCtrl = shortcut.toLowerCase().includes('ctrl');
    const containsAlt = shortcut.toLowerCase().includes('alt');
    const containsShift = shortcut.toLowerCase().includes('shift');
    const key = shortcut.split('+').pop() ?? '';

    const getSpanHTML = (text) => `
    <span class='py-0.25 px-1.5 flex-center h-4 rounded-sm bg-gray-600 text-white text-[10px]'>${text}</span>
  `;

    const ctrlHTML = containsCtrl ? getSpanHTML(isMac() ? '⌘' : 'Ctrl') : '';
    const altHTML = containsAlt ? getSpanHTML(isMac() ? '⌥' : 'Alt') : '';
    const shiftHTML = containsShift ? getSpanHTML('Shift') : '';

    return `
    <span class='flex flex-col items-center justify-center gap-1'>
      <span class='text-[10px] font-medium text-center'>${content}</span>
      <span class='flex gap-1 ${shortcut === '' ? 'hidden' : ''}'>
        ${ctrlHTML}
        ${altHTML}
        ${shiftHTML}
        ${getSpanHTML(key)}
      </span>
    </span>
  `;
}
